export default __webpack_public_path__ + "static/media/bgm-policy-icon.37939c20.png";